import { render, staticRenderFns } from "./EventAvatar.vue?vue&type=template&id=09821c0d&scoped=true&"
import script from "./EventAvatar.vue?vue&type=script&lang=js&"
export * from "./EventAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EventAvatar.vue?vue&type=style&index=0&id=09821c0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09821c0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09821c0d')) {
      api.createRecord('09821c0d', component.options)
    } else {
      api.reload('09821c0d', component.options)
    }
    module.hot.accept("./EventAvatar.vue?vue&type=template&id=09821c0d&scoped=true&", function () {
      api.rerender('09821c0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/events/EventAvatar.vue"
export default component.exports